import Vue from 'vue'
import Router from 'vue-router'
import { IsPC } from '@/utils/utils'
import '../assets/mob/js/normalize.min.js'

Vue.use(Router)

let routes = []
if (IsPC()) {
  // 如果是pc端  初始化路由
  routes = [
    {
      path: "/",
      component: () => import("@/layout/pc-layout"),
      redirect: "/home",
      children: [
        {
          path: "home",
          component: () => import("@/views/pc/home"),
          name: "home",
          meta: {
            title: "首页 " + process.env.VUE_APP_Name_CN,
          },
        },

        {
          path: "/solution",
          redirect: "/solution/0",
        },
        {
          path: "/solution/0",
          component: () => import("@/views/pc/solution-0"),
          name: "solution0",
          meta: {
            title: "乡村振兴数字化解决方案 " + process.env.VUE_APP_Name_CN,
          },
        },
        {
          path: "/solution/1",
          component: () => import("@/views/pc/solution-1"),
          name: "solution1",
          meta: {
            title: "农业单品行业大数据解决方案 " + process.env.VUE_APP_Name_CN,
          },
        },
        {
          path: "/solution/2",
          component: () => import("@/views/pc/solution-2"),
          name: "solution2",
          meta: {
            title: "农业链主企业数字化解决方案 " + process.env.VUE_APP_Name_CN,
          },
        },
        {
          path: "/solution/3",
          component: () => import("@/views/pc/solution-3"),
          name: "solution3",
          meta: {
            title: "现代农业产业园数字化解决方案 " + process.env.VUE_APP_Name_CN,
          },
        },
        {
          path: "/solution/4",
          component: () => import("@/views/pc/solution-4"),
          name: "solution4",
          meta: {
            title: "农产品区域公用品牌数字化解决方案 " + process.env.VUE_APP_Name_CN,
          },
        },
        {
          path: "/solution/5",
          component: () => import("@/views/pc/solution-5"),
          name: "solution5",
          meta: {
            title: "农产品交易中心数字化解决方案 " + process.env.VUE_APP_Name_CN,
          },
        },

        {
          path: "/news",
          component: () => import("@/views/pc/news"),
          name: "news",
          meta: {
            title: "动态 " + process.env.VUE_APP_Name_CN,
          },
        },
        {
          path: "/news/newsDetail/:id",
          component: () => import("@/views/pc/news-detail"),
          name: "newsDetail",
          meta: {
            title: "动态 " + process.env.VUE_APP_Name_CN,
          },
        },

        {
          path: "/partner",
          component: () => import("@/views/pc/partner"),
          name: "partner",
          meta: {
            title: "合作伙伴 " + process.env.VUE_APP_Name_CN,
          },
        },

        {
          path: "/about",
          component: () => import("@/views/pc/about"),
          name: "about",
          meta: {
            title: "公司简介 " + process.env.VUE_APP_Name_CN,
          },
        },
        {
          path: "/home/demo/:name",
          component: () => import("@/views/pc/demo"),
          name: "demo",
          meta: {
            title: "成功案例 " + process.env.VUE_APP_Name_CN,
          },
        },
      ],
    },
    {
      path: "/dat",
      component: () => import("@/views/mob/dat-newPC"),
      name: "dat",
      meta: {
        title: "农产品交易中心数字化解决方案",
      },
    },
  ];
} else {
  routes = [
    {
      path: "/",
      component: () => import("@/layout/mob-layout"),
      redirect: "/home",
      children: [
        {
          path: "home",
          component: () => import("@/views/mob/home"),
          name: "home",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-首页",
          },
        },

        {
          path: "/solution/0",
          component: () => import("@/views/mob/solution-0"),
          name: "solution0",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-乡村振兴数字化解决方案",
          },
        },
        {
          path: "/solution/1",
          component: () => import("@/views/mob/solution-1"),
          name: "solution1",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-农业单品行业大数据解决方案",
          },
        },
        {
          path: "/solution/2",
          component: () => import("@/views/mob/solution-2"),
          name: "solution2",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-农业链主企业数字化解决方案",
          },
        },
        {
          path: "/solution/3",
          component: () => import("@/views/mob/solution-3"),
          name: "solution3",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-现代农业产业园数字化解决方案",
          },
        },
        {
          path: "/solution/4",
          component: () => import("@/views/mob/solution-4"),
          name: "solution4",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-农产品区域公用品牌数字化解决方案",
          },
        },
        {
          path: "/solution/5",
          component: () => import("@/views/mob/solution-5"),
          name: "solution5",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-农产品批发市场/交易中心数字化解决方案",
          },
        },

        {
          path: "/news",
          component: () => import("@/views/mob/news"),
          name: "news",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-动态",
          },
        },
        {
          path: "/news/newsDetail/:id",
          component: () => import("@/views/mob/news-detail"),
          name: "mobNewsDetail",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-动态",
          },
        },
        {
          path: "/partner",
          component: () => import("@/views/mob/partner"),
          name: "partner",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-合作伙伴",
          },
        },
        {
          path: "/about",
          component: () => import("@/views/mob/about"),
          name: "about",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-公司简介",
          },
        },
        {
          path: "/home/demo/:name",
          component: () => import("@/views/mob/demo"),
          name: "demo",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-成功案例",
          },
        },
        {
          path: "/partners/:type",
          component: () => import("@/views/mob/partners"),
          name: "partner",
          meta: {
            title: process.env.VUE_APP_Name_CN + "-合作伙伴",
          },
        },
      ],
    },
    {
      path: "/dat",
      component: () => import("@/views/mob/dat-new"),
      name: "dat",
      meta: {
        title: "农产品交易中心数字化解决方案",
      },
    },
  ];
}

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0,
    }),
    // eslint-disable-next-line no-constant-condition
    routes: [
      ...routes,
      {
        path: '*',
        component: () => import('@/layout/404'),
      },
    ],
  })
const router = createRouter()
router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title
    if (title) {
      document.title = title
    }
    next()
})
export { router }
